import { render, staticRenderFns } from "./customer-create-wizard.vue?vue&type=template&id=5066ae31&scoped=true&"
import script from "./customer-create-wizard.vue?vue&type=script&lang=js&"
export * from "./customer-create-wizard.vue?vue&type=script&lang=js&"
import style0 from "./customer-create-wizard.vue?vue&type=style&index=0&id=5066ae31&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5066ae31",
  null
  
)

export default component.exports